import React from 'react';
import { Users, CheckCircle2, PauseCircle, XCircle } from 'lucide-react';
import type { TeamsListKPI } from '../types/teamsList.types';

interface TeamsListKPIProps {
  kpis: TeamsListKPI;
}

export function TeamsListKPI({ kpis }: TeamsListKPIProps) {
  const cards = [
    {
      label: 'Tổng số team',
      value: kpis.total,
      subLabel: 'đội nhóm',
      icon: Users,
      iconClass: 'bg-blue-50 text-blue-600',
    },
    {
      label: 'Đang hoạt động',
      value: kpis.active,
      percentage: kpis.total > 0 ? Math.round((kpis.active / kpis.total) * 100) : 0,
      icon: CheckCircle2,
      iconClass: 'bg-emerald-50 text-emerald-600',
    },
    {
      label: 'Tạm ngưng',
      value: kpis.paused,
      percentage: kpis.total > 0 ? Math.round((kpis.paused / kpis.total) * 100) : 0,
      icon: PauseCircle,
      iconClass: 'bg-amber-50 text-amber-600',
    },
    {
      label: 'Đã giải thể',
      value: kpis.disbanded,
      percentage: kpis.total > 0 ? Math.round((kpis.disbanded / kpis.total) * 100) : 0,
      icon: XCircle,
      iconClass: 'bg-rose-50 text-rose-600',
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, i) => (
        <div key={i} className="bg-white rounded-md p-4 border border-slate-100 flex items-center gap-4">
          <div className={`w-12 h-12 rounded-md ${card.iconClass} flex items-center justify-center shrink-0`}>
            <card.icon className="w-6 h-6" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="sm:text-sm text-xs text-slate-500 truncate">{card.label}</p>
            <div className="flex items-baseline gap-2">
              <span className="text-xl lg:text-2xl text-slate-900 leading-none">{card.value}</span>
              {card.subLabel && <span className="sm:text-sm text-xs text-slate-400">{card.subLabel}</span>}
              {card.percentage !== undefined && (
                <span className="sm:text-sm text-xs text-slate-400 ml-auto">{card.percentage}%</span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
